import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../../utils/api";

export const useRoles = () => {
	const { authGet } = useApi();

	const query = useQuery({
		queryKey: ["/user-roles"],
		queryFn: ({ queryKey }) => {
			const [url] = queryKey;
			return authGet(url, {
				params: {
					pagination: false,
				},
			});
		},
	});

	return {
		data: query.data?.result ?? [],
		isLoading: query.isLoading,
	};
};
